import type { AxiosRequestConfig } from 'axios';
import { assertRecordWritable } from '@/utils/recordReview';
import { post } from '@/utils/network/axios-helper';
import type { IPageDataBoxType, IGetAnswerList, ISaveAnswerList, IParamsType, IResult } from '@/utils/ctype';
import { EXAM_REQUEST_TIMEOUT_MS } from './start';

export const getReadingContent = (params: IParamsType, config?: AxiosRequestConfig) => {
  return post<{list: IPageDataBoxType[];}>('/api/simulate/get-reading-info', params, {
    timeout: EXAM_REQUEST_TIMEOUT_MS,
    ...config,
  });
};

export const getAnswerList = (params: IParamsType, config?: AxiosRequestConfig) => {
  return post<IGetAnswerList>('/api/simulate/get-reading-draft-info', params, {
    timeout: EXAM_REQUEST_TIMEOUT_MS,
    ...config,
  });
};

export const saveAnswerList = (params: ISaveAnswerList, config?: AxiosRequestConfig) => {
  assertRecordWritable();
  return post<{id: number;}>('/api/simulate/save-reading-info', params, {
    timeout: EXAM_REQUEST_TIMEOUT_MS,
    ...config,
  });
};

export const submitAnswer = (params: IParamsType, config?: AxiosRequestConfig) => {
  assertRecordWritable();
  return post<{id: number;}>('/api/simulate/finished-reading', params, {
    timeout: EXAM_REQUEST_TIMEOUT_MS,
    ...config,
  });
};

export const getResult = (params: IParamsType) => {
  return post<IResult>('/api/simulate/get-reading-record-answer-info', params);
};
